import React, { useState } from 'react';

// Icône SVG pour le menu (remplace Menu de lucide-react)
const MenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

// Icône SVG pour X (remplace X de lucide-react)
const XIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);


export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // J'ai adapté les liens du menu pour votre site PestGuard
  const navItems = [
    { href: '#hero', label: 'Accueil' },
    { href: '#services', label: 'Services' },
    { href: '#engagements', label: 'Engagements' },
    { href: '#pour-qui', label: 'Pour Qui ?' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <a href="#hero" className="flex items-center space-x-2">
              {/* IMPORTANT: Votre logo est dans /public, donc le chemin est "/logo.png" */}
              <img 
                src="/logo.png" // Assurez-vous que votre logo s'appelle bien "logo.png" dans le dossier /public
                alt="Logo PestGuard" 
                className="h-10 w-auto" // Ajustez la taille au besoin
                onError={(e) => e.target.src = 'https://placehold.co/40x40/2d8a4a/white?text=PG'} // Fallback
              />
              <span className="text-xl font-bold text-gray-800">PestGuard</span>
            </a>
          </div>

          {/* Navigation Desktop - Liens mis à jour */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-foreground hover:text-primary transition-colors duration-200 font-medium"
              >
                {item.label}
              </a>
            ))}
            {/* Bouton CTA - Remplacé par <button> */}
            <button
              className="bg-primary hover:bg-primary/90 text-white px-6 py-1.5 rounded-md text-sm font-medium" // J'ai ajouté les styles de "Button size=sm"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contactez-nous
            </button>
          </div>

          {/* Bouton menu mobile - Remplacé par <button> */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2"
            >
              {isMenuOpen ? (
                <XIcon className="h-6 w-6" /> // Utilise le SVG XIcon
              ) : (
                <MenuIcon className="h-6 w-6" /> // Utilise le SVG MenuIcon
              )}
            </button>
          </div>
        </div>

        {/* Navigation Mobile - Liens mis à jour */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block px-3 py-2 text-foreground hover:text-primary transition-colors duration-200 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="px-3 py-2">
                {/* Bouton CTA Mobile - Remplacé par <button> */}
                <button
                  className="w-full bg-primary hover:bg-primary/90 text-white px-3 py-2 rounded-md font-medium" // J'ai ajouté les styles
                  onClick={() => {
                    setIsMenuOpen(false);
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Contactez-nous
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}